const colors = require("tailwindcss/colors");
const IDS = require("./ids");

// from the main AECC Oncobarómetro website
const myColors = {
  primary: "#24c347",
  secondary: "#ffcc00",
  tertiary: "#373737",
  primarylight: "#e0f7ad",
  gray: colors.trueGray,
  c1: "#FF3C37",
  c2: "#FB7D7A",
  c3: "#FBAEAC",
  c4: "#6A97CE",
  c5: "#0A5FC8",
  "1light": "#ffeae9",
  nsnc: "#D9DAD9",
  lightgray: "#D9DAD9",
  darkgray: "#373737",
};

module.exports = {
  ...myColors,
  // we use CSS classes instead of colors for this one
  graph2: {
    [IDS.HAN_DISMINUIDO]: "bg-c5",
    [IDS.NO_HAN_AUMENTADO]: "bg-c4",
    [IDS.HAN_AUMENTADO_POCO]: "bg-c3",
    [IDS.HAN_AUMENTADO_BASTANTE]: "bg-c2",
    [IDS.HAN_AUMENTADO_MUCHO]: "bg-c1",
  },
  graph4: {
    0: myColors.c5, // nunca
    1: myColors.c4, // rara vez
    2: myColors.nsnc, // a veces
    3: myColors.c2, // a menudo
    4: myColors.c1, // siempre
  },
  graph5: {
    value: "bg-secondary",
    compare: "bg-lightgray",
  },
  graph6: {
    0: myColors.c5, // nunca
    1: myColors.c4, // raras veces
    2: myColors.c2, // algunas veces
    3: myColors.c1, // frecuentemente
  },
};
